import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBetPositionClientError } from '../../../../../../selectors/betPosition';
import { EUnavailableReason } from '../../../../../../types/reducers/publishTerms';
import { EBetPositionClientError } from '../../../../../../types/reducers/betPosition';
import { PriceAndGeoEmpty } from './components/PriceAndGeoEmpty';
import { GeoEmpty } from './components/GeoEmpty';
import { PriceEmpty } from './components/PriceEmpty';
import { selectServiceUnavailableReason } from '../../../../../../selectors/publishTerms';
import { NoPhotos } from './components/NoPhotos';
import { OnlyForFairPlayersContainer } from './components/onlyForFairPlayers';
import { DeniedBySanctions } from './components/DeniedBySanctions';
import { TopUnavailable } from './components/TopUnavailable';
import { OnlyAfterPremiumExpiration } from './components/OnlyAfterPremiumExpiration';
import { Autobroker } from './components/Autobroker';
import { getServiceName } from '../../../../../../utils/publishTerms';
import { PromotionWarningContainer } from '../PromotionWarning';
import {
  selectActiveServiceId,
  selectAuctionRestrictionType,
  selectPromotionTypeChangeReason,
} from '../../../../../../reducers/v2/promotion/selectors';
import { ERestrictionType } from '../../../../../../reducers/v2';

/**
 * Приоритет ошибок:
 * 1. Отображаем ошибку выбранной услуги, пришедшую с бэка (блокировка модератором, работаю честно и т.д.).
 * Пользователь не может разместиться с данной ошибкой.
 * При клике по "Разместить" подскроливаем к данной ошибке.
 *
 * 2. Отображаем ошибку запроса позиции (адрес не указан, цена не указана и т.д).
 * Пользователь может разместиться с данной ошибкой (поскольку позиция объявления - это вспомогательная информация для пользователя).
 *
 * 3. Отображаем ошибку "Загрузите фото, чтобы применить ТОП".
 *
 * 4. Отображаем ошибку автоброкера.
 * Пользователь может разместиться с данной ошибкой (автоброкер запрещает лишь ставить ставку).
 */
export const ServiceErrorContainer = () => {
  const clientError = useSelector(selectBetPositionClientError);
  const serviceId = useSelector(selectActiveServiceId);
  const unavailableReason = useSelector(selectServiceUnavailableReason);
  const promotionTypeChangeReason = useSelector(selectPromotionTypeChangeReason);
  const auctionBetUnavailable = useSelector(selectAuctionRestrictionType);

  const nominativeServiceName = serviceId ? getServiceName(serviceId, { wordCase: 'nominative' }) : '';

  if (promotionTypeChangeReason) {
    return <PromotionWarningContainer />;
  }

  if (unavailableReason) {
    switch (unavailableReason) {
      /**
       * @deprecated
       */
      case EUnavailableReason.NoServicesAvailable:
        return <OnlyForFairPlayersContainer />;

      case EUnavailableReason.DeniedBySanctions:
        return <DeniedBySanctions />;

      case EUnavailableReason.Top3ServiceDenied:
        return <TopUnavailable />;

      case EUnavailableReason.OnlyAfterPremiumServiceExpiration:
        return <OnlyAfterPremiumExpiration />;
    }
  }

  switch (clientError) {
    case EBetPositionClientError.priceAndGeoEmpty:
      return <PriceAndGeoEmpty />;

    case EBetPositionClientError.geoEmpty:
      return <GeoEmpty />;

    case EBetPositionClientError.priceEmpty:
      return <PriceEmpty />;
  }

  if (unavailableReason === EUnavailableReason.NoPhotos) {
    return <NoPhotos serviceName={nominativeServiceName} />;
  }

  if (auctionBetUnavailable === ERestrictionType.DeniedByStrategy) {
    return <Autobroker />;
  }

  return null;
};
